import script from "./submit.vue?vue&type=script&setup=true&lang=js"
export * from "./submit.vue?vue&type=script&setup=true&lang=js"

import "./submit.vue?vue&type=style&index=0&id=20049d7c&lang=scss&scoped=true"

import exportComponent from "E:\\newwww\\weimj\\agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20049d7c"]])

export default __exports__